import type { FaireProductEntity } from "../../entity_types/product";

export const p_nytyu2p8xf: FaireProductEntity = {
  token: "p_nytyu2p8xf",
  type: "product",
  name: "Wholesale 2 Lbs Tanzine Aura Quartz Freeform Crystal Healing",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/2d016110aa64ebef2d653c52f73122446fcd1b0e87da2819434de5499aa05087.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0fee6055a83c4c52ff6358448b10d14a172e537a3b40659d928836bf0f570b4b.jpeg",
    "https://cdn.faire.com/fastly/522172b8c347c39b0207c8c3cbb1192e4805b7eab1040901c2b0b51187a30cd1.jpeg",
    "https://cdn.faire.com/fastly/38c9ee66fa965d48b8938f8ba4f3328c7c1efb9945563b162f5fe18d0c1fa6f6.jpeg",
    "https://cdn.faire.com/fastly/e9d5dddc0fe14925101d19232817eac2b50848a3024d486b7417ea36b4fb980f.jpeg",
    "https://cdn.faire.com/fastly/e9dc312b25884f0b832bf0ee553ccd0181398229b8e00b2c5c06b6f9c26d0e0a.jpeg",
    "https://cdn.faire.com/fastly/6ff8bddf9ef93ad76cda76f6147d973f8d8dc1129638ea8975c266a92272ba24.jpeg",
    "https://cdn.faire.com/fastly/68383bec417ae0e0c07ace392e781f3a5dafbf340d6cb6e7e52e41b2092cdf3a.jpeg",
    "https://cdn.faire.com/fastly/f45d4b14d4e1f7af8a76b5236fbd3cfc8c7870ccc4de8d468405d0eb95bf770c.jpeg",
    "https://cdn.faire.com/fastly/e21cf668555518eb5c15f11b213d7713ca915b618e35d9acad16907105927539.jpeg",
  ],
  priceDollars: 97,
  description:
    "Enhance your collection with these eye-catching pieces feature a vibrant metallic rainbow coating that enhances the natural quartz, making them great for crystal collections, displays, or resale.\n\t•\tTotal weight: 2 lbs per lot\n\t•\tQuantity: Approximately 10 to 14 pieces per lot\n\t•\tMaterial: Tanzine Aura Quartz\n\t•\tShape: Freeform polished pieces\n\t•\tCondition: New\nMinimum order 6 pieces \n\nPlease note that natural quartz may contain natural inclusions, lines, or minor imperfections, which makes each piece unique.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 194,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:25.006Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
